import * as tslib_1 from "tslib";
import { Apollo } from 'apollo-angular';
import { ARCHIVE_EQUIPMENT_MUTATION, GET_EQUIPMENT_QUERY, LINK_EQUIPMENT_LINK_MUTATION, SEARCH_EQUIPMENTS_QUERY, SEARCH_EQUIPMENTS_WITH_WARRANTIES_QUERY, UNARCHIVE_EQUIPMENT_MUTATION, UPDATE_EQUIPMENT_MUTATION } from './equipment.query';
import * as i0 from "@angular/core";
import * as i1 from "apollo-angular";
var EquipmentsServiceApi = /** @class */ (function () {
    function EquipmentsServiceApi(apollo) {
        this.apollo = apollo;
    }
    EquipmentsServiceApi.prototype.get = function (id) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                return [2 /*return*/, this.apollo
                        .query({
                        query: GET_EQUIPMENT_QUERY,
                        variables: { id: id },
                    })
                        .toPromise()
                        .then(function (response) { return response.data && response.data.equipment; })];
            });
        });
    };
    EquipmentsServiceApi.prototype.search = function (params) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                return [2 /*return*/, this.apollo
                        .query({
                        query: SEARCH_EQUIPMENTS_QUERY,
                        variables: params,
                    })
                        .toPromise()
                        .then(function (response) { return response.data && response.data.equipments; })];
            });
        });
    };
    EquipmentsServiceApi.prototype.searchWithWarranties = function (params) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                return [2 /*return*/, this.apollo
                        .query({
                        query: SEARCH_EQUIPMENTS_WITH_WARRANTIES_QUERY,
                        variables: params,
                    })
                        .toPromise()
                        .then(function (response) { return response.data && response.data.equipments; })];
            });
        });
    };
    EquipmentsServiceApi.prototype.update = function (params) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                return [2 /*return*/, this.apollo.mutate({
                        mutation: UPDATE_EQUIPMENT_MUTATION,
                        variables: { input: params },
                    })
                        .toPromise()
                        .then(function (response) { return response.data && response.data.updateEquipment; })];
            });
        });
    };
    EquipmentsServiceApi.prototype.archive = function (params) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.apollo.mutate({
                            mutation: ARCHIVE_EQUIPMENT_MUTATION,
                            variables: { id: params.id },
                        })
                            .toPromise()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    EquipmentsServiceApi.prototype.unarchive = function (params) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.apollo.mutate({
                            mutation: UNARCHIVE_EQUIPMENT_MUTATION,
                            variables: { id: params.id },
                        }).toPromise()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    EquipmentsServiceApi.prototype.linkEquipment = function (params) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.apollo.mutate({
                            mutation: LINK_EQUIPMENT_LINK_MUTATION,
                            variables: { input: params },
                        }).toPromise()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    EquipmentsServiceApi.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function EquipmentsServiceApi_Factory() { return new EquipmentsServiceApi(i0.ɵɵinject(i1.Apollo)); }, token: EquipmentsServiceApi, providedIn: "root" });
    return EquipmentsServiceApi;
}());
export { EquipmentsServiceApi };
